import { SelectBox } from "components/Select/Select";
import {
  InputHTMLAttributes,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { trans } from "utils/helpers";
import { getApplicationWithRoute, setDefaultProcces } from "./api";

import { InputLoad } from "components/InputLoading/inputLoading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import {
  deleteProcessApplication,
  getProcessApplication,
  postProcessApplication,
} from "pages/OfficeAutomation/Settings/ProcessSetting/api/api";
import "./style.scss";
import { ICON_TYPE } from "utils/constants";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
interface ApplicationProp extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  PRJ_UID?: string;
  name: string;
  value?: any;
  mode?: any;
  valueList?: any;
  required?: boolean;
  Change?: (e) => void;
  ApplicationListCallback?: (e) => void;
}
export const ApplicationWithRoute = ({
  label,
  PRJ_UID,
  name,
  value,
  valueList,
  mode,
  required,
  Change,
  ApplicationListCallback,
}: ApplicationProp) => {
  const [
    optionsApplicationDictionarySelect,
    setOptionsApplicationDictionarySelect,
  ] = useState<any>({});
  const [optionsApplication, setOptionsApplication] = useState<any>();
  const [errcode, setErrcode] = useState<any>();
  const [app, setApp] = useState<any>();
  const [subMenu, setSubMenu] = useState<any>();

  const [selectedItem, setSelectedItem] = useState<any>([]);
  const [selectedSubMenuItem, setSelectedSubMenuItem] = useState<any>([]);
  const [subMenuOption, setSubMenuOption] = useState([]);
  const [subMenuValue, setSubMenuValue] = useState([]);

  const layoutContext = useContext(LayoutContext);
  let options_Application_values: any = [];
  let options_Application_keys: any = [];

  const ApplicationApiAsync = async () => {
    try {
      const res = await getApplicationWithRoute();
      const arry = [] as any;
      Object.keys(res.Data).map((item) =>
        arry.push({
          ApplicationId: item,
          ApplicationName: res.Data[item]?.[0]?.ApplicationName,
          SubMenu: [...res.Data[item]],
        })
      );

      setOptionsApplication(arry);
     
      setOptionsApplicationDictionarySelect(res.Data);
      
       if(!value){

          setApp(Object.keys(res.Data)[0]);
          setSubMenu("null");

setSubMenuOption([
        "",
        ...res.Data[Object.keys(res.Data)[0]].map((item) => item?.MenuTitle),
      ] as any);
      setSubMenuValue([
        "null",
        ...res.Data[Object.keys(res.Data)[0]].map((item) => item?.MenuId),
      ] as any);

      }else{
            setApp(value[0]?.ApplicationId)
    
      
setSubMenuOption([
        "",
        ...res.Data[value[0]?.ApplicationId].map((item) => item?.MenuTitle),
      ] as any);
      setSubMenuValue([
        "null",
        ...res.Data[value[0]?.ApplicationId].map((item) => item?.MenuId),
      ] as any);

      
      setSubMenu(value[0]?.SubMenuList?.[0]?.MenuId)
      }
    } catch (error: any) {
      setErrcode(error.response?.status);
    }
  };

  function addOption(e) {
    e.stopPropagation();
    e.preventDefault();
    let Name;
    let MenuTitle = "";
    let MenuRoute = "";

    if (app || options_Application_keys[0]) {
      let Id = app ? app : options_Application_keys[0];
      let MenuId = subMenu != "null" && subMenu ? subMenu : null;



      optionsApplication.forEach((item) => {
        if (item.ApplicationId == Id) {
          Name = item.ApplicationName;
          item?.SubMenu?.forEach((item1) => {
            if (item1.MenuId == MenuId) {
              MenuTitle = item1.MenuTitle ? item1.MenuTitle : "";
              MenuRoute = item1.MenuRoute ? item1.MenuRoute : "";
            }
          });
        }
      });

 
      if (ApplicationListCallback) {
        let selectList = JSON.parse(JSON.stringify(selectedItem));

        let list: any = [];


        let listId = selectList.map((item) => {
          item.SubMenuList.map((item1) => {
            if (item1.MenuId) {
              list.push(item1.MenuId);
            } else {
              list.push(item.ApplicationId);
            }
          });

       
        });

        if (
          (MenuId && !list.includes(MenuId)) ||
          (!MenuId && !list.includes(Id))
        ) {


          
          const filterItem= selectList.filter((item) => {
            return item.ApplicationId != Id;
          });

       const newSelectedItem=[
            ...filterItem,
            {
              ApplicationId: Id,
              ApplicationName: Name,
              SubMenuList: [
                ...(selectList.find((item) => item.ApplicationId == Id)
                  ? selectList.find((item) => item.ApplicationId == Id)
                      ?.SubMenuList
                  : []),
                { MenuId: MenuId, MenuRoute, MenuTitle },
              ],
            },
          ]



          setSelectedItem(newSelectedItem);
          ApplicationListCallback(newSelectedItem);
        }
      }
 
    }
  }

  async function deleteaOption(obj, child = null as any, submenu = false) {
    if (ApplicationListCallback) {
      let selectList: any = [];
     
        selectedItem.map((e) => {
          if (e.ApplicationId == obj.ApplicationId) {
            
            if(submenu){



            !!e.SubMenuList.filter(
                    (item1) => item1?.MenuId != child?.MenuId
                  )?.length  &&  selectList.push({
                  ...e,
                  SubMenuList: e.SubMenuList.filter(
                    (item1) => item1?.MenuId != child?.MenuId
                  ),
                });
            }else{


                !!e.SubMenuList.filter(
                    (item1) => item1?.MenuId 
                  )?.length &&
             selectList.push({
                  ...e,
                  SubMenuList: e.SubMenuList.filter(
                    (item1) =>{
          
                      
                     return item1?.MenuId!=null }
                  ),
                });   
            }
          } else {
 
            
            selectList.push(e);
          }
        });
    


      setSelectedItem(selectList);
     
      ApplicationListCallback(
       selectList
      );
    }
  }

  if (optionsApplication)
    options_Application_values = optionsApplication.map((item) => {
      return item.ApplicationName;
    });
  if (optionsApplication)
    options_Application_keys = optionsApplication.map((item) => {
      return item.ApplicationId;
    });

  useEffect(() => {
    if (value) {
      setSelectedItem(value);
      ApplicationListCallback && ApplicationListCallback(value);
  
    }
    ApplicationApiAsync();
  }, []);


  return (
    <>
      {label ? (
        <label className="Application__label">{trans(label)}</label>
      ) : null}
      {true ? (
        <>
          <form
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <div style={{ width: "90%" }}>
              <SelectBox
                onChange={(e) => {
                  setApp(e.target.value);
                  setSubMenu("null");
                  if (
                    optionsApplicationDictionarySelect?.[e.target.value]
                      ?.length > 0
                  ) {
                    setSubMenuOption([
                      "",
                      ...optionsApplicationDictionarySelect?.[
                        e.target.value
                      ].map((item) => item?.MenuTitle),
                    ] as any);
                    setSubMenuValue([
                      "null",
                      ...optionsApplicationDictionarySelect?.[
                        e.target.value
                      ].map((item) => item?.MenuId),
                    ] as any);
                  }
                  e.target.value !=
                  (value ? value : options_Application_keys[0])
                    ? Change && Change({ [name]: e.target.value })
                    : Change && Change({ [name]: null });
                }}
                required={required}
                mode={mode}
                lable="Application"
                selectType="select"
                value={app}
                options={options_Application_values}
                val={options_Application_keys}
                name={name}
              ></SelectBox>
            </div>

            {!!subMenuValue.length && (
              <div style={{ width: "90%" }} className="mx-2">
       
                <SelectBox
                  onChange={(e) => {

                    
                    setSubMenu(e.target.value);
                    e.target.value !=
                    (value ? value : options_Application_keys[0])
                      ? Change && Change({ [name]: e.target.value })
                      : Change && Change({ [name]: null });
                  }}
                  required={required}
                  mode={mode}
                  lable="submenu"
                  selectType="select"
                  value={subMenu}
                  options={subMenuOption}
                  val={subMenuValue}
                  name={name}
                ></SelectBox>
              </div>
            )}

            {mode != "view" && (
              <div style={{ marginTop: "22px", width: "10%" }}>
                <Button
                  Icon={true}
                  value={
                    <button onClick={addOption} className="checkButton">
                      {" "}
                      <FontAwesomeIcon icon={[ICON_TYPE, "check"]} size="2x" />
                    </button>
                  }
                  btnType="submit"
                />
              </div>
            )}
          </form>
          <div className="group-person__selected-options-wrapper">
            {selectedItem.map((item, index) =>
              item?.SubMenuList?.map((item1, index1) => {
                return item1?.MenuId ? (
                  <div
                    className="group-person__selected-option form-control-custom "
                    key={item1.MenuId + index1}
                  
                  >
                    <div
                      className="group-person__defult-selected-option"
                      data-key={item1.MenuId}
                    ></div>
                    <div
                      style={{
                        marginRight: ApplicationListCallback ? "0" : "13px",
                      }}
                    >
                      {trans(item.ApplicationName) + " _ " + item1.MenuTitle}
                    </div>

                    <div
                      className="group-person__delete-selected-option"
                      data-key={item1.MenuId}
                      onClick={() => {
                        deleteaOption(item, item1, true);
                      }}
                    >
                      <FontAwesomeIcon icon={[ICON_TYPE, "times"]} />
                    </div>
                  </div>
                ) : (
                  <div
                    className="group-person__selected-option form-control-custom"
                    key={item.ApplicationId + index}
                  >
                  
                    <div
                      className="group-person__defult-selected-option"
                      data-key={item.ApplicationId}
                    ></div>
                    <div
                      style={{
                        marginRight: ApplicationListCallback ? "0" : "13px",
                      }}
                    >
                      {trans(item.ApplicationName)}
                    </div>

                    <div
                      className="group-person__delete-selected-option"
                      data-key={item.ApplicationId}
                      onClick={() => {
                        deleteaOption(item);
                      }}
                    >
                      <FontAwesomeIcon icon={[ICON_TYPE, "times"]} />
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </>
      ) : (
        <InputLoad
          msg={errcode}
          required={required}
          labelText={label}
          onClick={ApplicationApiAsync}
        />
      )}
      <div className="text-box__msg-wrapper"></div>
    </>
  );
};
